import { Injectable, inject } from '@angular/core';
import { CanMatch, Route, UrlSegment, Router, UrlTree } from '@angular/router';

import { CompanyStore } from '~/core/store/company.store';
import { SportsbookProvider } from '~/core/enum/providers.enum';

@Injectable({ providedIn: 'root' })
export class NgxSportsOnlyGuard implements CanMatch {
  private router = inject(Router);
  private readonly companyStore = inject(CompanyStore);

  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const provider = this.companyStore.viewConfigSignal()?.sportsbook_screen?.provider || SportsbookProvider.NGX;

    if ([SportsbookProvider.ALTENAR, SportsbookProvider.BETBY, SportsbookProvider.FIRST].includes(provider)) {
      return this.router.parseUrl('/home');
    }

    return true;
  }
}
